import { Link } from 'react-router-dom';
import type { ComicItem } from '@/mocks/comics';

interface ComicCardProps {
  comic: ComicItem;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
              : 'bg-secondary-500 text-background-50 dark:text-foreground-950'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              {comic.rating}
            </span>
            <span className="whitespace-nowrap">{comic.chapters}话</span>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{comic.author}</p>
      </div>
    </Link>
  );
}